import React from "react";
import { Button, Icon, Popover } from "antd";
import { GroupSearch } from "../GroupSearch";
import { FormattedMessage } from "react-intl";

function SubGroupsFilter({ fetchedGroupId, currentGroup, subGroups }) {
  const [visible, setVisible] = React.useState(false);
  const groups = React.useMemo(() => {
    return subGroups.filter(
      (el) =>
        el.parent_id ===
        (currentGroup.groupType === "system"
          ? fetchedGroupId
          : currentGroup.parentId)
    );
  }, [fetchedGroupId, subGroups.length]);

  const toggleGroupSearchModal = () => {
    setVisible((v) => !v);
  };

  return (
    <Popover
      className={"GroupSearch"}
      trigger="click"
      placement="bottomLeft"
      visible={visible}
      onVisibleChange={toggleGroupSearchModal}
      content={
        <GroupSearch onItemClick={toggleGroupSearchModal} groups={groups} />
      }
    >
      <Button style={{ marginLeft: 8 }}>
        <FormattedMessage id="App.Text.SubGroups" defaultMessage="Sub Groups" />
        <Icon type="down" />
      </Button>
    </Popover>
  );
}

export default SubGroupsFilter;
